import React, { Component } from 'react';
import { connect } from 'react-redux';
import { isTest } from '../../helpers/environment';
import { Button, Icon, Typography } from 'rmwc';
import { Text } from '../../components/Text';
import { LoadingBar } from '../../components/util/LoadingBar';
import { SelectControl } from '../../components/controls/SelectControl';
import { SliderControl } from '../../components/controls/NewSliderControl';
import {
  MTAssumptionsSection,
  MTCalc,
  MTCTAv2,
  MTDivider,
  MTHeader,
  MTLearnMore,
  MTLearnMoreItem,
  MTScorePanel,
  MTSkinny,
  MTSubcontent,
  MTSubcontentH1,
  MTSubcontentH2,
  MTSubcontentHR,
  MTSubcontentLabel,
  MTSubcontentP,
  MTSubheading,
  MTWide,
} from './layout';
import MaxTaxAdvantagedSavingsChart from './MaxTaxAdvantagedSavingsChart';
import { currencyFormatter, Money, roundTo } from '../../components/Money';
import { withRegistrationDialog } from '../../components/RegistrationDialog';
import { withEmailDialog } from '../../components/EmailDialog';
import { runFullSimulation } from '../../actions/simulationActions';
import { fetchAccountsModule } from '../../actions/accountsActions';
import { fetchJobsModule } from '../../actions/jobsActions';
import { fetchPeople } from '../../actions/peopleActions';
import { fetchSavingsModule } from '../../actions/savingsActions';
import { updateTools } from '../../actions/toolsActions';
import { wlPath, wlVar } from '../../helpers/whitelabel';

const INCREMENT = 50;

// from 0 to $2000 in $50 increments
const dollarOptions = Array.from({ length: (2000 + INCREMENT) / INCREMENT }, (v, i) => i * INCREMENT);
const dollarOptionData = {};

dollarOptions.forEach(option => {
  dollarOptionData[option] = { label: `${currencyFormatter(option)}` };
});

export class ExpandableBox extends Component {
  constructor(props) {
    super(props);

    this.state = { open: false };
  }

  render() {
    return (
      <div style={{ borderTop: '1px solid #e0e0e0' }}>
        <div
          onClick={() => this.setState({ open: !this.state.open })}
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Text className="pl-2 mt-1 mb-0" use={this.props.titleTheme ? this.props.titleTheme : 'body1'}>
              {this.props.title}
            </Text>
            {this.props.sum !== undefined && this.props.sum !== null ? (
              <Text className="pl-4 mt-2 mb-0" use="subtitle1">
                {currencyFormatter(this.props.sum)}
                {this.props.perYear ? '' : '/month'}
              </Text>
            ) : null}
          </div>
          <Icon>{this.state.open ? 'keyboard_arrow_up' : 'add'}</Icon>
        </div>
        {this.state.open && <div>{this.props.children}</div>}
      </div>
    );
  }
}

const BoxRow = ({ title, children }) => (
  <div
    className="pl-2 pr-2 pb-1"
    style={{ background: '#f2f2f2', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}
  >
    {children}
  </div>
);

const boxRowSelectControlStyle = {
  width: '250px',
};

export class MaxTaxAdvantagedSavings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      roth401kAmount: 0,
      rothIRAAmount: 0,
      traditional401kAmount: 0,
      traditionalIRAAmount: 0,
      savingsAmount: 0,
      investmentBrokerageAmount: 0,
      totalSavingsAmount: 0,
      totalInvestmentBrokerageAmount: 0,

      percentInRetirementAccounts: 95,
      percentRegularConvertedToRetirementAccount: 95,

      outputs: [
        {
          name: 'With current accounts',
          amount: 0,
          withPlan: false,
        },
        {
          name: 'With account strategy',
          amount: 0,
          withPlan: true,
        },
      ],
    };
  }

  getStateFromProps(accounts, savings) {
    const total =
      accounts.normal_retirement_balance + accounts.regular_account_balance + accounts.roth_retirement_balance;

    const normalRetirementPercent = accounts.normal_retirement_balance / total;
    const rothRetirementPercent = accounts.roth_retirement_balance / total;

    const normalRetirementContribution =
      Math.floor(normalRetirementPercent * savings.primary_monthly_amount / INCREMENT) * INCREMENT;
    const rothRetirementContribution =
      Math.floor(rothRetirementPercent * savings.primary_monthly_amount / INCREMENT) * INCREMENT;
    const regularContribution =
      savings.primary_monthly_amount - normalRetirementContribution - rothRetirementContribution;
    this.setState(
      {
        traditional401kAmount: normalRetirementContribution,
        roth401kAmount: rothRetirementContribution,
        investmentBrokerageAmount: regularContribution,

        totalInvestmentBrokerageAmount: accounts.regular_account_balance,
      },
      this.calculateOutputs
    );
  }

  componentWillMount() {
    const { accounts, savings } = this.props;

    if (accounts && savings) {
      this.getStateFromProps(accounts, savings);
    }
  }

  componentWillReceiveProps = props => {
    const { accounts, savings } = props;
    if (accounts && savings && (!this.props.accounts || !this.props.savings)) {
      this.getStateFromProps(accounts, savings);
    }
  };

  componentDidMount() {
    if (!this.props.savings) this.props.fetchSavingsModule();
    if (!this.props.jobs) this.props.fetchJobsModule();
    if (!this.props.people) this.props.fetchPeople();
    if (!this.props.results) this.props.runFullSimulation();
    if (!this.props.accounts) this.props.fetchAccountsModule();
  }

  onChange = (evt, field) => {
    this.setState({ [field]: parseInt(evt.detail.value) }, this.calculateOutputs);
  };

  runSimulation = value => {
    // this.props.runFullSimulation('DASHBOARD_', {
    //   additional_balance: value,
    // });
  };

  calculateOutputs = () => {
    const { accounts, jobs, people } = this.props;

    const {
      investmentBrokerageAmount,
      percentInRetirementAccounts,
      percentRegularConvertedToRetirementAccount,
      roth401kAmount,
      rothIRAAmount,
      savingsAmount,
      totalInvestmentBrokerageAmount,
      totalSavingsAmount,
      traditional401kAmount,
      traditionalIRAAmount,
    } = this.state;

    const primaryAge = people[0].age;
    const primaryRetirementAge = jobs.primary_retirement_age;
    const yearsToRetirement = primaryRetirementAge - primaryAge;
    const realRateOfReturn = 0.045;

    const compoundedReturnRates = Array.from({ length: yearsToRetirement }, (v, i) =>
      Math.pow(1 + realRateOfReturn, i)
    );

    const compoundGrowthFactor = compoundedReturnRates.reduce((acc, curr) => acc + curr, 0);

    const incomeTaxNow = 0.2;
    const incomeTaxRetirement = 0.125;
    const capitalGainsTaxNow = 0.075;
    const capitalGainsTaxRetirement = 0.075;

    // Existing savings balances
    const traditionalSavingsBalanceCurrent = accounts.normal_retirement_balance;
    const rothSavingsBalanceCurrent = accounts.roth_retirement_balance;
    const regularSavingsBalanceCurrent = totalSavingsAmount + totalInvestmentBrokerageAmount;

    const traditionalSavingsBalanceWithStrategy =
      traditionalSavingsBalanceCurrent +
      regularSavingsBalanceCurrent * percentRegularConvertedToRetirementAccount / 100;
    const rothSavingsBalanceWithStrategy = accounts.roth_retirement_balance;
    const regularSavingsBalanceWithStrategy =
      regularSavingsBalanceCurrent * (100 - percentRegularConvertedToRetirementAccount) / 100;

    // if (isTest()) {
    //   console.log(
    //     'savings balances CURR',
    //     traditionalSavingsBalanceCurrent,
    //     rothSavingsBalanceCurrent,
    //     regularSavingsBalanceCurrent
    //   );
    //   console.log(
    //     'savings balances WPLA',
    //     traditionalSavingsBalanceWithStrategy,
    //     rothSavingsBalanceWithStrategy,
    //     regularSavingsBalanceWithStrategy
    //   );
    // }

    // Ongoing savings contributions
    const traditionalSavingsContributionCurrent = traditional401kAmount + traditionalIRAAmount;
    const rothSavingsContributionCurrent = roth401kAmount + rothIRAAmount;
    const regularSavingsContributionCurrent = savingsAmount + investmentBrokerageAmount;

    const traditionalSavingsContributionWithStrategy =
      (traditionalSavingsContributionCurrent + regularSavingsContributionCurrent) * percentInRetirementAccounts / 100;
    const rothSavingsContributionWithStrategy = rothSavingsContributionCurrent;
    const regularSavingsContributionWithStrategy =
      (traditionalSavingsContributionCurrent + regularSavingsContributionCurrent) *
      (100 - percentInRetirementAccounts) /
      100;

    // if (isTest()) {
    //   console.log(
    //     'ongoing savings contributions CURR',
    //     traditionalSavingsContributionCurrent,
    //     rothSavingsContributionCurrent,
    //     regularSavingsContributionCurrent
    //   );
    //   console.log(
    //     'ongoing savings contributions WPLA',
    //     traditionalSavingsContributionWithStrategy,
    //     rothSavingsContributionWithStrategy,
    //     regularSavingsContributionWithStrategy
    //   );
    // }

    // Total balance at retirement
    const totalTraditionalBalanceRetirementCurrent =
      traditionalSavingsBalanceCurrent * Math.pow(1 + realRateOfReturn, yearsToRetirement) +
      traditionalSavingsContributionCurrent * 12 * compoundGrowthFactor;
    const totalRothBalanceRetirementCurrent =
      rothSavingsBalanceCurrent * Math.pow(1 + realRateOfReturn, yearsToRetirement) +
      rothSavingsContributionCurrent * 12 * compoundGrowthFactor;
    const totalRegularBalanceRetirementCurrent =
      regularSavingsBalanceCurrent * Math.pow(1 + realRateOfReturn, yearsToRetirement) +
      regularSavingsContributionCurrent * 12 * compoundGrowthFactor;

    const totalTraditionalBalanceRetirementWithStrategy =
      traditionalSavingsBalanceWithStrategy * Math.pow(1 + realRateOfReturn, yearsToRetirement) +
      traditionalSavingsContributionWithStrategy * 12 * compoundGrowthFactor;
    const totalRothBalanceRetirementWithStrategy =
      rothSavingsBalanceWithStrategy * Math.pow(1 + realRateOfReturn, yearsToRetirement) +
      rothSavingsContributionWithStrategy * 12 * compoundGrowthFactor;
    const totalRegularBalanceRetirementWithStrategy =
      regularSavingsBalanceWithStrategy * Math.pow(1 + realRateOfReturn, yearsToRetirement) +
      regularSavingsContributionWithStrategy * 12 * compoundGrowthFactor;

    // if (isTest()) {
    //   console.log(
    //     'total bal @ retirement CURR',
    //     totalTraditionalBalanceRetirementCurrent,
    //     totalRothBalanceRetirementCurrent,
    //     totalRegularBalanceRetirementCurrent
    //   );
    //   console.log(
    //     'total bal @ retirement WPLA',
    //     totalTraditionalBalanceRetirementWithStrategy,
    //     totalRothBalanceRetirementWithStrategy,
    //     totalRegularBalanceRetirementWithStrategy
    //   );
    // }

    // Outputs
    const incomeTaxesOngoingContributionsCurrent =
      (traditionalSavingsContributionCurrent * 12 +
        rothSavingsContributionCurrent * 12 +
        regularSavingsContributionCurrent * 12) *
      incomeTaxNow /
      (1 - incomeTaxNow) *
      yearsToRetirement;
    const taxShieldOnContributionsCurrent =
      -(traditionalSavingsContributionCurrent * 12) * incomeTaxNow / (1 - incomeTaxNow) * yearsToRetirement;
    const taxOnWithdrawalsCurrent =
      totalTraditionalBalanceRetirementCurrent * incomeTaxRetirement +
      totalRegularBalanceRetirementCurrent * capitalGainsTaxRetirement;

    const incomeTaxesOngoingContributionsWithStrategy =
      (traditionalSavingsContributionWithStrategy * 12 +
        rothSavingsContributionWithStrategy * 12 +
        regularSavingsContributionWithStrategy * 12) *
      incomeTaxNow /
      (1 - incomeTaxNow) *
      yearsToRetirement;
    const taxShieldOnContributionsWithStrategy =
      -(traditionalSavingsContributionWithStrategy * 12) * incomeTaxNow / (1 - incomeTaxNow) * yearsToRetirement;
    const taxShieldOnConversionWithStrategy =
      -(traditionalSavingsBalanceWithStrategy - traditionalSavingsBalanceCurrent) * incomeTaxNow;
    const taxOnWithdrawalsWithStrategy =
      totalTraditionalBalanceRetirementWithStrategy * incomeTaxRetirement +
      totalRegularBalanceRetirementWithStrategy * capitalGainsTaxRetirement;

    // if (Test()) {
    //   console.log(
    //     'outputs CURR',
    //     incomeTaxesOngoingContributionsCurrent,
    //     taxShieldOnContributionsCurrent,
    //     0,
    //     taxOnWithdrawalsCurrent
    //   );
    //   console.log(
    //     'outputs WPLA',
    //     incomeTaxesOngoingContributionsWithStrategy,
    //     taxShieldOnContributionsWithStrategy,
    //     taxShieldOnConversionWithStrategy,
    //     taxOnWithdrawalsWithStrategy
    //   );
    // }

    const totalTaxesCurrent =
      incomeTaxesOngoingContributionsCurrent + taxShieldOnContributionsCurrent + taxOnWithdrawalsCurrent;
    const totalTaxesWithStrategy =
      incomeTaxesOngoingContributionsWithStrategy +
      taxShieldOnContributionsWithStrategy +
      taxShieldOnConversionWithStrategy +
      taxOnWithdrawalsWithStrategy;

    const outputs = [
      {
        name: 'With current accounts',
        amount: roundTo(totalTaxesCurrent, -2),
        withPlan: false,
      },
      {
        name: 'With account strategy',
        amount: roundTo(totalTaxesWithStrategy, -2),
        withPlan: true,
      },
    ];

    const totalGrossUp = -(
      taxShieldOnConversionWithStrategy +
      taxShieldOnConversionWithStrategy -
      taxShieldOnContributionsCurrent
    );

    // needs to pass total gross up in cents, not dollars
    this.runSimulation(totalGrossUp * 100);

    this.setState({ outputs });
    this.props.updateTools({
      active: 'Tax Savings',
      dollarsGained: outputs[0].amount - outputs[1].amount,
    });
  };

  render() {
    const { accounts, history, jobs, people, results, savings, updatedResults } = this.props;

    if (!accounts || !jobs || !people || !results || !savings) {
      return <LoadingBar />;
    }

    return (
      <div>
        <MTHeader title="Maximize your Tax-Advantaged Savings" onClick={() => history.push(wlPath('/action-plan'))} />
        <MTSkinny>
          <MTSubheading title="What are retirement accounts, and why do they matter?" />
          <MTSubcontent noCard>
            <MTSubcontentP>
              401(k) and IRA were created to help you save for retirement by allowing you avoid income taxes. Most
              people have one, but many are not taking full advantage of the contributions, especially as they near
              retirement.
            </MTSubcontentP>
            <MTSubcontentP last>
              <strong>We can figure our how to max out your contributions, and save on taxes.</strong>
            </MTSubcontentP>
          </MTSubcontent>
        </MTSkinny>
        <MTDivider />
        <MTWide>
          <MTSubheading title="How much could retirement accounts impact your retirement?" />
          <MTCalc
            title="Retirement tax savings calculator"
            left={
              <div>
                <ExpandableBox
                  title="Put more of your monthly savings into retirement accounts"
                  titleTheme="subheading1"
                >
                  <MTSubcontentLabel>
                    Use the slider to see how shifting savings contributions to retirement accounts affects your taxes.
                  </MTSubcontentLabel>
                  <div style={{ background: '#e0f3ff' }}>
                    <Text use="body1">
                      <strong>Savings Contribution Split (Normal vs. Retirement Accounts)</strong>
                    </Text>
                    <div className="p-2">
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Text use="body1" className="mb-0">
                          {'Regular Accounts'}
                        </Text>
                        <Text use="body1" className="mb-0">
                          {'Retirement Accounts'}
                        </Text>
                      </div>
                      <SliderControl
                        style={{ width: '80%', margin: 'auto' }}
                        spec={{
                          field_type: 'range',
                          min: 0,
                          max: 100,
                          step_size: 5,
                          _default: 95,
                        }}
                        onChange={evt => this.onChange(evt, 'percentInRetirementAccounts')}
                        onInput={evt => this.onChange(evt, 'percentInRetirementAccounts')}
                        value={this.state.percentInRetirementAccounts}
                        discrete
                        persistentPin
                      />
                    </div>
                  </div>
                </ExpandableBox>

                <ExpandableBox title="Convert your regular savings into retirement accounts" titleTheme="subheading1">
                  <MTSubcontentLabel>
                    Use the slider to see how converting some of your regular savings into retirement accounts could
                    affect your taxes.
                  </MTSubcontentLabel>
                  <div style={{ background: '#e0f3ff' }}>
                    <Text use="body1">
                      <strong>Amount of Regular Savings Converted to Retirement Accounts</strong>
                    </Text>
                    <div className="p-2">
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Text use="body1" className="mb-0">
                          {'0%'}
                        </Text>
                        <Text use="body1" className="mb-0">
                          {'100%'}
                        </Text>
                      </div>
                      <SliderControl
                        style={{ width: '80%', margin: 'auto' }}
                        spec={{
                          field_type: 'range',
                          min: 0,
                          max: 100,
                          step_size: 5,
                          _default: 95,
                        }}
                        onChange={evt => this.onChange(evt, 'percentRegularConvertedToRetirementAccount')}
                        onInput={evt => this.onChange(evt, 'percentRegularConvertedToRetirementAccount')}
                        value={this.state.percentRegularConvertedToRetirementAccount}
                        discrete
                        persistentPin
                      />
                    </div>
                  </div>
                </ExpandableBox>

                <MTSubcontentHR />
                <MTSubcontentH2 title="Lifetime total taxes you'll pay" />
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  <MaxTaxAdvantagedSavingsChart data={this.state.outputs} />
                </div>
              </div>
            }
            right={
              <MTAssumptionsSection title="Your Current Savings Accounts" titleStyle="subheading2">
                <div className="hrbr-form">
                  <div className="p-2" />
                  <ExpandableBox
                    title="Contribution to Roth Accounts"
                    sum={this.state.roth401kAmount + this.state.rothIRAAmount}
                  >
                    <BoxRow>
                      <SelectControl
                        style={boxRowSelectControlStyle}
                        value={this.state.roth401kAmount}
                        spec={{
                          field_type: 'single_choice',
                          options: dollarOptions,
                          option_data: dollarOptionData,
                        }}
                        label="Roth 401k"
                        onChange={evt => this.onChange(evt, 'roth401kAmount')}
                      />
                    </BoxRow>
                    <BoxRow>
                      <SelectControl
                        style={boxRowSelectControlStyle}
                        value={this.state.rothIRAAmount}
                        spec={{
                          field_type: 'single_choice',
                          options: dollarOptions,
                          option_data: dollarOptionData,
                        }}
                        label="Roth IRA"
                        onChange={evt => this.onChange(evt, 'rothIRAAmount')}
                      />
                    </BoxRow>
                  </ExpandableBox>

                  <ExpandableBox
                    title="Contribution to Traditional Accounts"
                    sum={this.state.traditional401kAmount + this.state.traditionalIRAAmount}
                  >
                    <BoxRow>
                      <SelectControl
                        style={boxRowSelectControlStyle}
                        value={this.state.traditional401kAmount}
                        spec={{
                          field_type: 'single_choice',
                          options: dollarOptions,
                          option_data: dollarOptionData,
                        }}
                        label="Traditional 401k, 403b, 457b"
                        onChange={evt => this.onChange(evt, 'traditional401kAmount')}
                      />
                    </BoxRow>
                    <BoxRow>
                      <SelectControl
                        style={boxRowSelectControlStyle}
                        value={this.state.traditionalIRAAmount}
                        spec={{
                          field_type: 'single_choice',
                          options: dollarOptions,
                          option_data: dollarOptionData,
                        }}
                        label="Traditional IRA"
                        onChange={evt => this.onChange(evt, 'traditionalIRAAmount')}
                      />
                    </BoxRow>
                  </ExpandableBox>

                  <ExpandableBox
                    title="Contribution to Regular Accounts"
                    sum={this.state.savingsAmount + this.state.investmentBrokerageAmount}
                  >
                    <BoxRow>
                      <SelectControl
                        style={boxRowSelectControlStyle}
                        value={this.state.savingsAmount}
                        spec={{
                          field_type: 'single_choice',
                          options: dollarOptions,
                          option_data: dollarOptionData,
                        }}
                        label="Savings"
                        onChange={evt => this.onChange(evt, 'savingsAmount')}
                      />
                    </BoxRow>
                    <BoxRow>
                      <SelectControl
                        style={boxRowSelectControlStyle}
                        value={this.state.investmentBrokerageAmount}
                        spec={{
                          field_type: 'single_choice',
                          options: dollarOptions,
                          option_data: dollarOptionData,
                        }}
                        label="Investment/Brokerage"
                        onChange={evt => this.onChange(evt, 'investmentBrokerageAmount')}
                      />
                    </BoxRow>
                  </ExpandableBox>

                  <ExpandableBox
                    title="Total Savings in Regular Accounts"
                    sum={this.state.totalSavingsAmount + this.state.totalInvestmentBrokerageAmount}
                    perYear
                  >
                    <BoxRow>
                      <SelectControl
                        style={boxRowSelectControlStyle}
                        value={this.state.totalSavingsAmount}
                        spec={accounts._spec.fields.regular_account_balance}
                        label="Savings"
                        onChange={evt => this.onChange(evt, 'totalSavingsAmount')}
                      />
                    </BoxRow>
                    <BoxRow>
                      <SelectControl
                        style={boxRowSelectControlStyle}
                        value={this.state.totalInvestmentBrokerageAmount}
                        spec={accounts._spec.fields.regular_account_balance}
                        label="Investment/Brokerage"
                        onChange={evt => this.onChange(evt, 'totalInvestmentBrokerageAmount')}
                      />
                    </BoxRow>
                  </ExpandableBox>
                </div>
              </MTAssumptionsSection>
            }
          />
        </MTWide>
        <MTSkinny>
          <Text use="caption" className="text-muted">
          These calculators are designed to be informational and educational tools only, and when used alone, do not constitute investment advice. We strongly recommend that you seek the advice of a financial services professional before making any type of investment. We also encourage you to review your investment strategy periodically as your financial circumstances change. This model is provided as a rough approximation of future financial performance. The results presented by this calculator are hypothetical and may not reflect the actual growth of any investments. {wlVar('brand_name')} is not responsible for the consequences of any decisions or actions taken in reliance upon or as a result of the information provided by these tools.
          </Text>
        </MTSkinny>

        {/*<div style={{ display: 'flex' }}>
          <MTSkinny>
            <MTSubheading title="How much could retirement accounts impact your retirement?" />
            <MTSubcontent>
              <MTSubcontentH1 title="Retirement tax savings calculator" />

              <ExpandableBox title="Put more of your monthly savings into retirement accounts" titleTheme="subheading1">
                <MTSubcontentLabel>
                  Use the slider to see how shifting savings contributions to retirement accounts affects your taxes.
                </MTSubcontentLabel>
                <div style={{ background: '#e0f3ff' }}>
                  <Text use="body1">
                    <strong>Savings Contribution Split (Normal vs. Retirement Accounts)</strong>
                  </Text>
                  <div className="p-2">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Text use="body1" className="mb-0">
                        {'Regular Accounts'}
                      </Text>
                      <Text use="body1" className="mb-0">
                        {'Retirement Accounts'}
                      </Text>
                    </div>
                    <SliderControl
                      style={{ width: '80%', margin: 'auto' }}
                      spec={{
                        field_type: 'range',
                        min: 0,
                        max: 100,
                        step_size: 5,
                        _default: 50,
                      }}
                      onChange={evt => this.onChange(evt, 'percentInRetirementAccounts')}
                      onInput={evt => this.onChange(evt, 'percentInRetirementAccounts')}
                      value={this.state.percentInRetirementAccounts}
                      discrete
                      persistentPin
                    />
                  </div>
                </div>
              </ExpandableBox>

              <ExpandableBox title="Convert your regular savings into retirement accounts" titleTheme="subheading1">
                <MTSubcontentLabel>
                  Use the slider to see how converting some of your regular savings into retirement accounts could
                  affect your taxes.
                </MTSubcontentLabel>
                <div style={{ background: '#e0f3ff' }}>
                  <Text use="body1">
                    <strong>Amount of Regular Savings Converted to Retirement Accounts</strong>
                  </Text>
                  <div className="p-2">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                      <Text use="body1" className="mb-0">
                        {'0%'}
                      </Text>
                      <Text use="body1" className="mb-0">
                        {'100%'}
                      </Text>
                    </div>
                    <SliderControl
                      style={{ width: '80%', margin: 'auto' }}
                      spec={{
                        field_type: 'range',
                        min: 0,
                        max: 100,
                        step_size: 5,
                        _default: 50,
                      }}
                      onChange={evt => this.onChange(evt, 'percentRegularConvertedToRetirementAccount')}
                      onInput={evt => this.onChange(evt, 'percentRegularConvertedToRetirementAccount')}
                      value={this.state.percentRegularConvertedToRetirementAccount}
                      discrete
                      persistentPin
                    />
                  </div>
                </div>
              </ExpandableBox>

              <MTSubcontentHR />
              <MTSubcontentH2 title="Lifetime total taxes you'll pay" />
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <MaxTaxAdvantagedSavingsChart data={this.state.outputs} />
              </div>
              <MTAssumptionsSection title="Your Current Savings Accounts" titleStyle="subheading2">
                <div className="p-2" />
                <ExpandableBox
                  title="Contribution to Roth Accounts"
                  sum={this.state.roth401kAmount + this.state.rothIRAAmount}
                >
                  <BoxRow title="Roth 401(k)">
                    <SelectControl
                      value={this.state.roth401kAmount}
                      spec={{
                        field_type: 'single_choice',
                        options: dollarOptions,
                        option_data: dollarOptionData,
                      }}
                      onChange={evt => this.onChange(evt, 'roth401kAmount')}
                    />
                  </BoxRow>
                  <BoxRow title="Roth IRA">
                    <SelectControl
                      value={this.state.rothIRAAmount}
                      spec={{
                        field_type: 'single_choice',
                        options: dollarOptions,
                        option_data: dollarOptionData,
                      }}
                      onChange={evt => this.onChange(evt, 'rothIRAAmount')}
                    />
                  </BoxRow>
                </ExpandableBox>

                <ExpandableBox
                  title="Contribution to Traditional Accounts"
                  sum={this.state.traditional401kAmount + this.state.traditionalIRAAmount}
                >
                  <BoxRow title="Traditional 401(k) | 403(b) | 457(b)">
                    <SelectControl
                      value={this.state.traditional401kAmount}
                      spec={{
                        field_type: 'single_choice',
                        options: dollarOptions,
                        option_data: dollarOptionData,
                      }}
                      onChange={evt => this.onChange(evt, 'traditional401kAmount')}
                    />
                  </BoxRow>
                  <BoxRow title="Traditional IRA">
                    <SelectControl
                      value={this.state.traditionalIRAAmount}
                      spec={{
                        field_type: 'single_choice',
                        options: dollarOptions,
                        option_data: dollarOptionData,
                      }}
                      onChange={evt => this.onChange(evt, 'traditionalIRAAmount')}
                    />
                  </BoxRow>
                </ExpandableBox>

                <ExpandableBox
                  title="Contribution to Regular Accounts"
                  sum={this.state.savingsAmount + this.state.investmentBrokerageAmount}
                >
                  <BoxRow title="Savings">
                    <SelectControl
                      value={this.state.savingsAmount}
                      spec={{
                        field_type: 'single_choice',
                        options: dollarOptions,
                        option_data: dollarOptionData,
                      }}
                      onChange={evt => this.onChange(evt, 'savingsAmount')}
                    />
                  </BoxRow>
                  <BoxRow title="Investment/Brokerage">
                    <SelectControl
                      value={this.state.investmentBrokerageAmount}
                      spec={{
                        field_type: 'single_choice',
                        options: dollarOptions,
                        option_data: dollarOptionData,
                      }}
                      onChange={evt => this.onChange(evt, 'investmentBrokerageAmount')}
                    />
                  </BoxRow>
                </ExpandableBox>

                <ExpandableBox
                  title="Total Savings in Regular Accounts"
                  sum={this.state.totalSavingsAmount + this.state.totalInvestmentBrokerageAmount}
                  perYear
                >
                  <BoxRow title="Savings">
                    <SelectControl
                      value={this.state.totalSavingsAmount}
                      spec={accounts._spec.fields.regular_account_balance}
                      onChange={evt => this.onChange(evt, 'totalSavingsAmount')}
                    />
                  </BoxRow>
                  <BoxRow title="Investment/Brokerage">
                    <SelectControl
                      value={this.state.totalInvestmentBrokerageAmount}
                      spec={accounts._spec.fields.regular_account_balance}
                      onChange={evt => this.onChange(evt, 'totalInvestmentBrokerageAmount')}
                    />
                  </BoxRow>
                </ExpandableBox>
              </MTAssumptionsSection>
            </MTSubcontent>
            <Button
              className="mt-4"
              onClick={() =>
                this.props.openRegistrationDialog(() => (window.location = '/start'), () => {}, 'SAVE_AND_REVISIT')
              }
              theme="secondary"
            >
              Save this page for later
            </Button>
          </MTSkinny>
        </div>*/}
        <MTDivider />
        <MTSkinny>
          <MTSubheading title="Start securing your tax benefits right away" />
          <MTCTAv2
            title="Start with a free tax account analysis."
            subtitle="Take just 15 minutes to save $23,000."
            image={require('images/outcome-fees.png')}
            description={
              'On a short call, we\'ll analyze your current situation to see how much more tax savings you could benefit from, including a "catching-up" on past years!'
            }
            buttonTextSecondary="Save for later"
            onClickSecondary={() =>
              this.props.openRegistrationDialog(() => (window.location = '/start'), () => {}, 'SAVE_AND_REVISIT')
            }
            buttonTextPrimary="Schedule free analysis"
            onClickPrimary={() => {}}
            talkingPointsHeading="Things we'll do during your account analysis"
            talkingPointsSubheading="Here are some tips to get you started"
            talkingPointsImage={require('images/icon-situation')}
            talkingPoints={[
              {
                image: require('images/outcome-fees.png'),
                label: "Determine which account types you're eligible for.",
                text: <div />,
              },
              {
                image: require('images/icon_investments.png'),
                label: 'Decide how much to keep saving in regular acounts.',
                text: <div />,
              },
              {
                image: require('images/icon-options.png'),
                label: 'Create a "catch-up" strategy to put more regular savings into tax-advantaged accounts.',
                text: <div />,
              },
            ]}
          />

          {/*<MTCTA
            title="Start with a free tax account analysis."
            subtitle="Take just 15 minutes to save $23,000."
            image={require('images/outcome-fees.png')}
            description={
              'On a short call, we\'ll analyze your current situation to see how much more tax savings you could benefit from, including a "catching-up" on past years!'
            }
            buttonTextSecondary="Save for later"
            onClickSecondary={() =>
              this.props.openRegistrationDialog(() => (window.location = '/start'), () => {}, 'SAVE_AND_REVISIT')
            }
            buttonTextPrimary="Schedule free analysis"
            talkingPointsHeading="Things we'll do during your account analysis"
            talkingPoints={[
              {
                image: require('images/outcome-fees.png'),
                label: "Determine which account types you're eligible for.",
              },
              {
                image: require('images/icon_investments.png'),
                label: 'Decide how much to keep saving in regular acounts.',
              },
              {
                image: require('images/icon-options.png'),
                label: 'Create a "catch-up" strategy to put more regular savings into tax-advantaged accounts.',
              },
            ]}
          />*/}
        </MTSkinny>
        <MTDivider />
        <MTSkinny>
          <MTSubheading title="Learn more" />
          <MTLearnMore>
            <MTLearnMoreItem title="Alphabet soup explained: what's the difference between a 401k, 403b, 429 IRA, SEP">
              <Text use="body1" tag="p" className="pb-1">
                They are different savings accounts. Your eligibility for, and the advantage of, each of them depends on
                your employer and your income. In one way or another, all of these savings accounts offer the benefit of
                delaying or eliminating the need to pay certain taxes. Using them these accounts correctly for your
                situation can be worth a lot of money over time.
              </Text>
            </MTLearnMoreItem>
            <MTLearnMoreItem title="How does a retirement account work?">
              <Text use="body1" tag="p" className="pb-1">
                A retirement account functions a lot like a savings account, except the money you put into the account
                is only supposed to be used to save for an age when you are closer to retirement. If you use the money
                before you reach retirement age, you’ll have to pay high taxes and a large fee Generally, retirement
                accounts are a type of “brokerage account” that can be used for buying and selling investments like
                stocks and bonds and mutual funds that helps your money grow over time (hopefully into much more by
                retirement).
              </Text>
            </MTLearnMoreItem>
            <MTLearnMoreItem title="The difference between Roth & Traditional accounts">
              <Text use="body1" tag="p" className="pb-1">
                Traditional accounts mean that you save the money in them before taxes, and that you don’t pay any taxes
                on gains and interest earned in the account until you withdraw your money. This has an advantage of
                helping you grow your money quickly and if your taxes are lower in retirement than they are while
                working, saving you a lot of money on taxes.
              </Text>
              <Text use="body1" tag="p" className="pb-1">
                Roth account means you pay all the taxes upfront and never have to pay taxes on the money again, as long as certain guidelines are met.  You
                won’t grow you money as quickly, but all the money you save and earn in Roth accounts is yours to keep.
                It’s a particularly great account type for people who want to do the hard work to save a lot for
                retirement.
              </Text>
            </MTLearnMoreItem>
            <MTLearnMoreItem title="What if I want to keep some money in regular accounts, in case I need it before retirement?">
              <Text use="body1" tag="p" className="pb-1">
                It’s a good idea to have savings for emergencies and for the important wants and needs of your everyday
                life. You should always have some savings in regular accounts. The downside is that if you save too much
                in regular accounts, you will end up paying more in taxes then you needed to pay. It takes work to
                figure out exactly how much is the right amount to save so that you can manage your taxes, but have enough
                for your important wants and needs.
              </Text>
            </MTLearnMoreItem>
          </MTLearnMore>
        </MTSkinny>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    accounts: state.modules.accounts.data,
    jobs: state.modules.jobs.data,
    people: state.people.data,
    results: state.simulations.results,
    savings: state.modules.savings.data,
    updatedResults: state.modules.dashboard.simulation ? state.modules.dashboard.simulation.results : null,
  };
}

export default connect(mapStateToProps, {
  fetchAccountsModule,
  fetchJobsModule,
  fetchPeople,
  fetchSavingsModule,
  runFullSimulation,
  updateTools,
})(withEmailDialog(withRegistrationDialog(MaxTaxAdvantagedSavings)));
